import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { FallbackService } from '@lib-core/fallback/services/fallback.service';
import { MaintenanceStoreService } from '@lib-core/maintenance/services/maintenance-store.service';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard {
  /**
   * constructor
   *
   */
  constructor(
    private maintenanceStoreService: MaintenanceStoreService,
    private fallbackService: FallbackService,
  ) {}

  /**
   * canActivate
   *
   */
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.maintenanceStoreService.getIsActiveFromStore$().pipe(
      take(1),
      tap((isActive) => {
        if (isActive) this.fallbackService.activate();
      }),
      map((isActive) => !isActive),
    );
  }
}
